import Vue from 'vue'
import Router from 'vue-router'
import Articles from '@/components/Articles'
import Fonti from '@/components/Fonti'
import Conoscermi from '@/components/Conoscermi'
import Usarmi from '@/components/Usarmi'
import Cambiare from '@/components/Cambiare'
import Numeri from '@/components/Numeri'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Articles,
      meta: { transitionName: 'slide-reverse' }
    },
    {
      path: '/fonti',
      component: Fonti,
    },
    {
      path: '/paura-di-conoscermi',
      component: Conoscermi,
      meta: { transitionName: 'slide' }
    },
    {
      path: '/paura-di-usarmi',
      component: Usarmi,
      meta: { transitionName: 'slide' }
    },
    {
      path: '/paura-di-cambiare',
      component: Cambiare,
      meta: { transitionName: 'slide' }
    },
    {
      path: '/paura-di-numeri',
      component: Numeri,
      meta: { transitionName: 'slide' }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js